<template>
  <g fill="white">
    <path
      d="M3.4725 8.66666H10.9192L7.66583 11.92C7.40583 12.18 7.40583 12.6067 7.66583 12.8667C7.92583 13.1267 8.34583 13.1267 8.60583 12.8667L12.9992 8.47332C13.2592 8.21332 13.2592 7.79332 12.9992 7.53332L8.6125 3.13332C8.48794 3.00849 8.31884 2.93833 8.1425 2.93833C7.96615 2.93833 7.79705 3.00849 7.6725 3.13332C7.4125 3.39332 7.4125 3.81332 7.6725 4.07332L10.9192 7.33332H3.4725C3.10583 7.33332 2.80583 7.63332 2.80583 7.99999C2.80583 8.36666 3.10583 8.66666 3.4725 8.66666Z"
    />
  </g>
</template>
